<script>
export default {
    props: {
        steps: {
            type: Array,
            required: true,
        },
        step: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            mounted: false,
        };
    },
    computed: {
        visibleSteps() {
            return this.steps.filter(i => !i.disabled);
        },
        progressWidth() {
            const {step, steps, visibleSteps} = this;
            let width = 0;
            if (this.mounted) {
                for (let i = 0; i < step; i++) {
                    if (!steps[i].disabled) {
                        width += 100 / visibleSteps.length;
                    }
                }
            }
            return {
                width: `${width}%`,
            };
        },
    },
    mounted() {
        this.mounted = true;
    },
};
</script>

<template>
    <div class="Stepper">
        <div class="Progress">
            <div class="Bar" :style="progressWidth"></div>
            <div
                v-for="(s, i) in visibleSteps"
                class="Tick"
                :key="i"
                :style="{left: `${i * (100 / visibleSteps.length)}%`}"
            />
        </div>
        <div class="Steps">
            <template></template>
            <div
                v-for="(s, i) in steps"
                :class="{Step: true, Current: i < step, CurrentLast: i === step - 1, Disabled: s.disabled}"
                :key="i"
                :ref="`step${i}`"
            >
                <span v-html="$t(s.title)"></span>
            </div>
        </div>
    </div>
</template>

<style lang="stylus" scoped>
@import '../../stylus/vars.styl'

.Stepper
    width 100%
    overflow hidden
    .Progress
        position relative
        height 4px
        background $cBorder
        .Bar
            background $cAccent
            height 4px
            width 50%
            transition .6s all
        .Tick
            position absolute
            background rgba(0,0,0,.1)
            width 1px
            height 100%
            top 0
    .Steps
        display flex
        .Step
            flex 1 1 100%
            overflow hidden
            text-align center
            padding 16px 10px
            color darken($cBorder, 10%)
            text-transform lowercase
            transition all .5s
            &.Current
                color $cPrimary
                font-weight 700
            &.Disabled
                display none
            span
                text-transform none
</style>
